import React, { useState } from 'react';
import { motion } from 'framer-motion';

const AFFILIATE_TAG = 'tumanodice-20';
const AMAZON_DOMAIN = 'amazon.com';

function url(busqueda) {
  return `https://www.${AMAZON_DOMAIN}/s?k=${encodeURIComponent(busqueda)}&tag=${AFFILIATE_TAG}`;
}

function imgUrl(asin) {
  return `https://images-na.ssl-images-amazon.com/images/P/${asin}.01.LZZZZZZZ.jpg`;
}

const PRODUCTOS = [
  {
    busqueda:  'tarot rider waite original deck',
    asin:      'B000XUYNQM',
    nombre:    'Tarot Rider Waite',
    sub:       'El mazo más leído del mundo',
    estrellas: 4.8,
    reviews:   '12,400+',
    badge:     '🔥 Más vendido',
    glow:      '255,215,0',
  },
  {
    busqueda:  'palmistry hand reading book guide',
    asin:      '0789401452',
    nombre:    'Libro de Quiromancia',
    sub:       'Guía completa de lectura de manos',
    estrellas: 4.6,
    reviews:   '3,200+',
    badge:     '✋ Como en Selene',
    glow:      '147,112,219',
  },
  {
    busqueda:  'healing crystals kit chakra stones set',
    asin:      'B07V1G95H7',
    nombre:    'Kit Cristales Sanadores',
    sub:       '7 piedras de chakra + guía',
    estrellas: 4.7,
    reviews:   '8,900+',
    badge:     '💎 Recomendado',
    glow:      '233,69,96',
  },
];

function Estrellas({ valor }) {
  return (
    <span style={{ color: '#FFD700', fontSize: '0.78rem', letterSpacing: '1px' }}>
      {[1,2,3,4,5].map(i => (
        <span key={i} style={{ opacity: i <= Math.round(valor) ? 1 : 0.25 }}>★</span>
      ))}
      <span style={{ color: 'var(--color-texto-suave)', fontSize: '0.7rem', marginLeft: '4px' }}>
        {valor}
      </span>
    </span>
  );
}

function TarjetaProducto({ p, index }) {
  const [hover, setHover]       = useState(false);
  const [imgError, setImgError] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.15 * index }}
      style={{ flex: '1 1 160px', maxWidth: '200px' }}
    >
      <a
        href={url(p.busqueda)}
        target="_blank"
        rel="noopener noreferrer sponsored"
        style={{ textDecoration: 'none', display: 'block', height: '100%' }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <motion.div
          animate={{
            scale:     hover ? 1.04 : 1,
            boxShadow: hover
              ? `0 8px 32px rgba(${p.glow},0.35), 0 0 0 1px rgba(${p.glow},0.5)`
              : `0 2px 12px rgba(${p.glow},0.10), 0 0 0 1px rgba(${p.glow},0.2)`,
          }}
          transition={{ type: 'spring', stiffness: 300, damping: 22 }}
          style={{
            background:    `rgba(${p.glow},0.06)`,
            borderRadius:  '16px',
            overflow:      'hidden',
            cursor:        'pointer',
            height:        '100%',
            display:       'flex',
            flexDirection: 'column',
          }}
        >
          {/* Badge */}
          <div style={{
            background:    `rgba(${p.glow},0.18)`,
            padding:       '0.3rem 0.7rem',
            fontSize:      '0.68rem',
            fontWeight:    '700',
            color:         `rgb(${p.glow})`,
            textAlign:     'center',
            letterSpacing: '0.3px',
          }}>
            {p.badge}
          </div>

          {/* Imagen */}
          <div style={{
            background:      'rgba(255,255,255,0.04)',
            display:         'flex',
            alignItems:      'center',
            justifyContent:  'center',
            padding:         '1rem',
            minHeight:       '130px',
          }}>
            {!imgError ? (
              <img
                src={imgUrl(p.asin)}
                alt={p.nombre}
                onError={() => setImgError(true)}
                style={{
                  maxHeight:  '110px',
                  maxWidth:   '100%',
                  objectFit:  'contain',
                  borderRadius: '6px',
                  filter:     hover ? 'brightness(1.12)' : 'brightness(1)',
                  transition: 'filter 0.3s',
                }}
              />
            ) : (
              <div style={{ fontSize: '3rem' }}>📦</div>
            )}
          </div>

          {/* Info */}
          <div style={{ padding: '0.8rem', flex: 1, display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
            <div style={{ color: 'var(--color-texto)', fontWeight: '700', fontSize: '0.82rem', lineHeight: 1.3 }}>
              {p.nombre}
            </div>
            <div style={{ color: 'var(--color-texto-suave)', fontSize: '0.72rem', lineHeight: 1.3 }}>
              {p.sub}
            </div>
            <Estrellas valor={p.estrellas} />
            <div style={{ color: 'var(--color-texto-suave)', fontSize: '0.65rem' }}>
              {p.reviews} reseñas
            </div>
          </div>

          {/* CTA */}
          <motion.div
            animate={{ background: hover ? `rgba(${p.glow},0.25)` : `rgba(${p.glow},0.10)` }}
            style={{
              padding:       '0.6rem',
              textAlign:     'center',
              borderTop:     `1px solid rgba(${p.glow},0.2)`,
              color:         `rgb(${p.glow})`,
              fontWeight:    '700',
              fontSize:      '0.78rem',
              letterSpacing: '0.3px',
            }}
          >
            {hover ? '¡Ver en Amazon →' : 'Ver precio →'}
          </motion.div>
        </motion.div>
      </a>
    </motion.div>
  );
}

function Afiliados() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.4 }}
      style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid rgba(255,215,0,0.15)' }}
    >
      {/* Cabecera */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{ textAlign: 'center', marginBottom: '1.5rem' }}
      >
        <div style={{ fontSize: '1.6rem', marginBottom: '0.4rem' }}>🌙</div>
        <p style={{ color: 'var(--color-oro)', fontWeight: '700', fontSize: '1rem', marginBottom: '0.3rem' }}>
          Selene recomienda para tu camino
        </p>
        <p style={{ color: 'var(--color-texto-suave)', fontSize: '0.8rem' }}>
          Herramientas que complementan lo que tu mano revela
        </p>
      </motion.div>

      {/* Productos */}
      <div style={{ display: 'flex', gap: '0.9rem', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'stretch' }}>
        {PRODUCTOS.map((p, i) => (
          <TarjetaProducto key={p.asin} p={p} index={i} />
        ))}
      </div>

      {/* Disclaimer */}
      <p style={{ textAlign: 'center', color: 'var(--color-texto-suave)', fontSize: '0.65rem', marginTop: '1.2rem', opacity: 0.45 }}>
        Como Asociado de Amazon gano por compras calificadas.
      </p>
    </motion.div>
  );
}

export default Afiliados;
